import React from 'react';
import {View, BasicTextInput} from '../../react-core-components';
import {
  WithLabel,
  WithInputWrapper,
  WithVariant,
  InputError,
  getInputProps,
} from '../../react-input-wrapper';

class TextInput extends React.Component {
  render() {
    let inputProps = getInputProps(this.props);
    return (
      <View style={{flexDirection: 'row'}}>
        <View style={{flex: 1, overflow: 'hidden'}}>
          <BasicTextInput {...inputProps} />
        </View>
        <InputError {...this.props} />
      </View>
    );
  }
}

TextInput = WithLabel(WithInputWrapper(WithVariant(TextInput)));

export default TextInput;
